import { ref, watch } from 'vue'

const STORAGE_KEY = 'phoneMaskEnabled'

export function usePhoneMask() {
  const phoneMaskEnabled = ref(localStorage.getItem(STORAGE_KEY) !== 'false')

  watch(phoneMaskEnabled, (val) => {
    localStorage.setItem(STORAGE_KEY, val)
  })

  const maskPhone = (phone) => {
    if (!phone || phone.length < 7) return phone || ''
    if (!phoneMaskEnabled.value) return phone
    return phone.slice(0, 3) + '****' + phone.slice(-4)
  }

  return { phoneMaskEnabled, maskPhone }
}
